import React from "react";
import styles from "../../styles/FaqPageStyle.module.css";
import {
  Card,
  CardBody,
  Collapse,
} from "reactstrap";
import { useState } from "react";
import { AiOutlinePlusCircle, AiOutlineMinusCircle } from "react-icons/ai";
import Question from "../../assets/imgs/EF Branding Website/334731_quora_icon.png";
import Answer from "../../assets/imgs/EF Branding Website/letter-a (1).png";
const QuesFour = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
      setIsOpen(!isOpen);
    };
  return (
    <div>
      <div className="d-flex justify-content-center align-items-center">
        <img src={Question} alt="" style={{ width: "30px", height: "30px" }} />
        <button id="toggler4" className={styles.btn} onClick={toggle}>
          <span style={{ textAlign: "left" }}> Where are our offices and warehouses?</span>
          {!isOpen ? (
            <div className={styles.icon_container}>
              <AiOutlinePlusCircle className={styles.icon} />
            </div>
          ) : (
            <div className={styles.icon_container}>
              <AiOutlineMinusCircle className={styles.icon} />
            </div>
          )}
        </button>
      </div>
      <Collapse isOpen={isOpen}>
        <div className="d-flex mt-3">
          <img src={Answer} alt="" className={styles.img} />
          <Card style={{ width: "100%" }}>
            <CardBody>
              <ul>
                <li className="d-flex flex-column mb-3">
                  <span>● Yangon Office:</span>
                  <span className="ps-3">
                    No. H-7, May Kha Housing ,May Kha Street, Thingungyun
                    Township, Yangon.
                  </span>
                </li>
                <li className="d-flex flex-column mb-3">
                  <span>● Yangon Warehouse:</span>
                  <span className="ps-3">
                    No.115/1, Khayaypin Road (R1 road), Sagaing Street (8th
                    Street), ZaykabarCompound, Mingalardon Township, Yangon.
                  </span>
                </li>
                <li className="d-flex flex-column mb-3">
                  <span>● Mandalay Office:</span>
                  <span className="ps-3">
                    N2,Swel Taw Compound, Between143 street & 146 street/Between
                    62 street & 67 street, Mandalay.
                  </span>
                </li>
                <li className="d-flex flex-column mb-3">
                  <span>● Myawaddy Office:</span>
                  <span className="ps-3">
                    Kone Thwel Yay Zone, Ever green fine art company compound,
                    Land No. 14, Myawwady.
                  </span>
                </li>
                <li className="d-flex flex-column mb-3">
                  <span>● Dongguan Branch (China Office):</span>
                  <span className="ps-3">
                    No.A15-A16, Building A, Gaosheng Logistics Park, No.6 Baima
                    Xianfeng Road, Nancheng Jiedao,Dongguan City, Guangdong
                    Province,China. Tel: 13316683535
                  </span>
                </li>
                <li className="d-flex flex-column mb-3">
                  <span>● Yiwu Branch (China Office):</span>
                  <span className="ps-3">
                    No.10,Anshang street,er shi san he zhai industrial zone,Yiwu
                    city,Jinhua ciyt,Zhenjiang.
                  </span>
                </li>
              </ul>
            </CardBody>
          </Card>
        </div>
      </Collapse>
    </div>
  );
};
export default QuesFour;
